// // =======================================
// // Home.jsx — Main Landing Page for App
// // =======================================

// import React from "react";
// import { Link } from "react-router-dom";

// // --- Global App Components ---
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// // --- Stylesheet ---
// import "../styles/Home.css";

// // ========== Main Home Page Component ==========
// const Home = () => {
//   return (
//     <div className="min-h-screen flex flex-col bg-white">
//       {/* Header */}
//       <Header />

//       {/* Main Content - centered and fills remaining space */}
//       <main className="flex-1 flex items-center justify-center px-4 sm:px-8 md:px-12 lg:px-16 py-12 md:py-16 w-full">
//         <div className="max-w-7xl w-full p-8">
//           {/* Title */}
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0c0c1d] mb-6 leading-tight">
//             Welcome to{" "}
//             <span className="text-[#ff2e2e] block mt-2">
//               MAGICS
//               <span className="block text-2xl sm:text-3xl md:text-[1.75rem] text-[#ff4a4a] mt-2 font-bold">
//                 Mapping and Assessment of Generated Ideas in Conceptual Spaces
//               </span>
//             </span>
//           </h1>

//           {/* Description */}
//           <div className="text-base sm:text-lg text-gray-700 leading-relaxed space-y-4">
//             <p>
//               Explore your ideas like never before! Shortlist your ideas visually...
//             </p>

//             <p>
//               MAGICS is your interactive platform for visualizing, analyzing, and
//               understanding ideas in a mathematical way. We've got intuitive
//               tools to help you dig deep and discover patterns in your ideas. With
//               MAGICS, you can effortlessly explore and analyze your ideas, and make
//               informed decisions based on your findings.
//             </p>

//             <p className="font-semibold">
//               Magically turn your ideas into insights with MAGICS!
//             </p>
//           </div>

//           {/* Login Button */}
//           <div className="mt-8">
//             <a href="/login">
//               <button className="bg-[#ff2e2e] text-white font-semibold px-8 py-3 rounded-lg shadow-[0_4px_12px_rgba(255,46,46,0.4)] hover:bg-[#e60000] transition-all duration-300 transform hover:scale-105 text-lg w-full sm:w-auto">
//                 Get Started
//               </button>
//             </a>
//           </div>
//         </div>
//       </main>

//       {/* Footer */}
//       <Footer />
//     </div>
//   );
// };


// export default Home;
import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Home = () => {
  const location = useLocation();
  const showLogin = location.pathname === "/login";

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />

      <div className={`flex-1 flex flex-col lg:flex-row overflow-hidden ${showLogin ? 'justify-center items-center' : ''}`}>
        {/* Home Content - Hidden on mobile when login is shown */}
        <main className={`
          ${showLogin ? 'hidden lg:flex' : 'flex'}
          flex-1 lg:flex-[0.6] items-center justify-center px-6 sm:px-8 md:px-12 lg:px-16 py-12 md:py-16 overflow-y-auto
        `}>
          <div className="max-w-3xl w-full">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0c0c1d] mb-6 leading-tight font-['Montserrat']">
              Welcome to{" "}
              <span className="text-[#ff2e2e] block mt-2">
                MAGICS
                <span className="block text-2xl sm:text-3xl md:text-[1.75rem] text-[#ff4a4a] mt-2 font-bold">
                  Mapping and Assessment of Generated Ideas in Conceptual Spaces
                </span>
              </span>
            </h1>

            <div className="text-base sm:text-lg text-gray-700 leading-relaxed space-y-4 font-['Montserrat']">
              <p>
                Explore your ideas like never before! Shortlist your ideas visually...
              </p>

              <p>
                MAGICS is your interactive platform for visualizing, analyzing, and
                understanding ideas in a mathematical way. We've got intuitive
                tools to help you dig deep and discover patterns in your ideas. With
                MAGICS, you can effortlessly explore and analyze your ideas, and make
                informed decisions based on your findings.
              </p>

              <p className="font-semibold">
                Magically turn your ideas into insights with MAGICS!
              </p>
            </div>

            <div className="mt-8">
              <Link to="/login">
                <button className="bg-[#ff2e2e] text-white font-semibold font-['Montserrat'] px-8 py-3 rounded-lg shadow-[0_4px_12px_rgba(255,46,46,0.4)] hover:bg-[#e60000] transition-all duration-300 transform hover:scale-105 text-lg w-full sm:w-auto">
                  Get Started
                </button>
              </Link>
            </div>
          </div>
        </main>

        {/* Login Panel - Outlet for nested route */}
        {showLogin && (
          <aside className="
            fixed lg:relative inset-0 lg:inset-auto
            lg:flex-[0.4] lg:border-l lg:border-gray-200
            z-50 lg:z-auto
            bg-white
            transition-all duration-300
          ">
            <Outlet />
          </aside>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Home;